import { render } from "./Opportunities.vue?vue&type=template&id=15257ac7&scoped=true"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"

import "./Opportunities.vue?vue&type=style&index=0&id=15257ac7&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15257ac7"]])

export default __exports__